export default __webpack_public_path__ + "static/media/logo.3dc94e19.png";